export const alertWithoutTitle = message => {
  const iframe = document.createElement('IFRAME');
  iframe.id = 'iframes';
  iframe.style.display = 'none';
  iframe.setAttribute('src', 'DUMMY');
  document.documentElement.appendChild(iframe);
  window.frames[0].window.alert(message);
  iframe.parentNode.removeChild(iframe);
};
